import type { BrandId } from "@msb/reader-bridge";

/** Application mobile de la marque : schéma d'URL et fiches des stores. */
export interface MobileApp {
  /** Paquet Android et schéma d'URL déclarés par l'app (AndroidManifest, Info.plist). */
  packageName: string;
  scheme: string;
  host: string;
  playStoreUrl: string;
  appStoreUrl: string;
}

export const mobileApps: Partial<Record<BrandId, MobileApp>> = {
  mysmartbook: {
    packageName: "fr.mysmartbook.app",
    scheme: "fr.mysmartbook.app",
    host: "app.mysmartbook.fr",
    playStoreUrl: "https://play.google.com/store/apps/details?id=fr.mysmartbook.app",
    appStoreUrl: "https://apps.apple.com/fr/app/mysmartbook/id6756213702",
  },
};

export type MobilePlatform = "android" | "ios" | "other";

export function mobilePlatform(userAgent: string, maxTouchPoints = 0): MobilePlatform {
  if (/android/i.test(userAgent)) return "android";
  // iPadOS se présente comme un Mac : on le reconnaît à l'écran tactile.
  if (/iphone|ipad|ipod/i.test(userAgent) || (/macintosh/i.test(userAgent) && maxTouchPoints > 1)) return "ios";
  return "other";
}

/**
 * Lien qui ouvre l'app. Android : lien « intent » qui bascule sur le Play Store si l'app
 * n'est pas installée. iOS : schéma de l'app (le repli vers l'App Store est fait par openApp).
 */
export function appLaunchUrl(app: MobileApp, platform: MobilePlatform): string {
  if (platform === "android") {
    const fallback = encodeURIComponent(app.playStoreUrl);
    return `intent://${app.host}/#Intent;scheme=${app.scheme};package=${app.packageName};S.browser_fallback_url=${fallback};end`;
  }
  if (platform === "ios") return `${app.scheme}://${app.host}/`;
  return app.playStoreUrl;
}

/** Ouvre l'app sur mobile ; sur iOS, renvoie vers l'App Store si elle ne s'est pas ouverte. */
export function openApp(app: MobileApp, platform: MobilePlatform): void {
  window.location.href = appLaunchUrl(app, platform);
  if (platform !== "ios") return;
  const started = Date.now();
  window.setTimeout(() => {
    // Page toujours au premier plan après 1,5 s : l'app n'est pas installée.
    if (document.visibilityState === "visible" && Date.now() - started < 3000) window.location.href = app.appStoreUrl;
  }, 1500);
}
